module.exports = __webpack_public_path__ + "static/media/IconClock.1df24d54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/IconClock.svg
// module id = 947
// module chunks = 0